import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { SecondaryOffer } from 'components/Offer/Secondary';
import { useOfferContainer } from 'hooks/useOfferContainer';
import { getAnchorPrice, getAnchorPriceTotal, getOfferEntity } from 'modules/sapiSearch/selectors';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { Hotel } from '@findhotel/sapi';
import { AllOffersDropdownLoader } from './AllOffersDropdownLoader';
const OfferWrapper = /*#__PURE__*/styled('div')({
  name: "OfferWrapper",
  class: "o9fv018",
  propsAsIs: false
});
interface Props {
  hotelId: Hotel['objectID'];
}

// Added as part of df9r3t7e-desktop-more-deals-dropdown
export const AllOffersDropdown = ({
  hotelId
}: Props) => {
  const {
    brandCashbackEnabled
  } = useBrand();
  const topOffersAnchorPrice = useSelector(state => getAnchorPrice(state, hotelId));
  const topOffersAnchorPriceTotal = useSelector(state => getAnchorPriceTotal(state, hotelId));
  const offerEntity = useSelector(state => getOfferEntity(state, hotelId));
  const {
    allOffers
  } = useOfferContainer({
    offerEntity,
    hotelId
  });

  // remove the 3 top offers from the list
  const offers = allOffers.slice(Number(process.env.NEXT_PUBLIC_VISIBLE_TOP_OFFERS_LIMIT));
  return <>
      {offers.length > 0 ? offers.map(offer => <OfferWrapper key={offer.id}>
            <SecondaryOffer sourceComponent="ExperimentalMoreDealsDropdown" variant="SecondaryInline" offer={offer} hotelId={hotelId} isSplitBooking={false} anchorPriceTotal={topOffersAnchorPriceTotal} anchorPrice={topOffersAnchorPrice} hasRoomLabels={false} hasInteraction={true} hasArrowCTA={false} showCashback={brandCashbackEnabled} />
          </OfferWrapper>) : <AllOffersDropdownLoader />}
    </>;
};

require("./AllOffersDropdown.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AllOffersDropdown.tsx");